import ReactDOM from 'react-dom/client';
import App from './app';

const documentElement = document.getElementById('root');

if (!documentElement) {
	throw new Error('No root element found');
}

ReactDOM.createRoot(documentElement).render(<App />);
